import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import cN from 'classnames';
import styles from '../styles.module.scss';
import { updateFilterItems } from '@utils/utils';
import { filterTypesKey, I_FilterItem, I_Group, I_Tag, I_Type } from '@Redux/search/interfaces';
import { setFilterItems, setChangeItem } from '@Redux/search/actions';
import { RootState } from '@Redux/search/store';
import * as Tag from '@components/Common/Tag';
import { ArrowUp } from '@components/Common/Icons/index';

interface I_Props {
    TripTypeName: string;
    TripTypeCode: string;
    GroupList: I_Group[];
    CategoryCode: string;
}

const Type: React.FC<I_Props> = ({ TripTypeName, TripTypeCode, GroupList, CategoryCode }) => {
    const moduleName = 'type';
    const dispatch = useDispatch();
    const { FilterItems, TagFiltersShow } = useSelector((state: RootState) => state.search);
    const [isOverflow, setisOverflow] = useState<boolean>(false); // "更多"按鈕相關 state
    const [isExtended, setIsExtended] = useState<boolean>(false); // "更多"按鈕相關 state
    const ListContentRef = useRef<HTMLUListElement>(null); // "更多"按鈕相關 state
    const isTripCategory = CategoryCode === '03';
    const showDetail = isTripCategory ? TagFiltersShow.indexOf(TripTypeCode) !== -1 : true;
    const isMobile = useMediaQuery({ query: '(max-width: 980px)' });

    useEffect(() => {
        //
        if (ListContentRef.current && showDetail && CategoryCode === '03') {
            // PC 版時 && 所有標籤的高度超過 1 行以上
            !isMobile && ListContentRef.current.scrollHeight > 40 && setisOverflow(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showDetail]);

    return isTripCategory ? (
        <li className={cN(styles[`${moduleName}`], showDetail ? styles.Show : '')}>
            <div className={styles.ListTile}>
                <span>{TripTypeName}</span>
            </div>
            <ul
                className={cN(styles.ListContent, {
                    [`${styles.isExtended}`]: isExtended,
                })}
                ref={ListContentRef}
            >
                {GroupList.map(({ TagList }: I_Group) => {
                    return TagList.map(({ TagName, TagNo }: I_Tag) => {
                        const newVal = `${TagNo}`;
                        const isActive = FilterItems.filter(
                            (item: I_FilterItem) => item.value === newVal
                        );
                        const props = {
                            data: FilterItems,
                            nowType: filterTypesKey.CategoryList,
                            text: TagName,
                            value: newVal,
                            subValue: TripTypeCode,
                        };
                        return (
                            <li
                                key={`${TagNo}${TagName}`}
                                className={styles.Tagwrap}
                                onClick={() => {
                                    const newFilterItems = updateFilterItems(props);
                                    dispatch(setFilterItems(newFilterItems));
                                    dispatch(setChangeItem(true));
                                }}
                            >
                                <Tag.Selectable text={TagName} isActive={isActive.length !== 0} />
                            </li>
                        );
                    });
                })}
            </ul>
            {!isMobile && isOverflow && (
                <div
                    className={styles.ListToggleBtn}
                    onClick={() => {
                        setIsExtended(!isExtended);
                    }}
                >
                    <span>{isExtended ? '收起' : '更多'}</span>
                    <div className={cN(styles.Icon, { up: isExtended })}>
                        <ArrowUp fill="#669" />
                    </div>
                </div>
            )}
        </li>
    ) : (
        <>
            {GroupList.map(({ TagList }: I_Group) => {
                return TagList.map(({ TagName, TagNo }: I_Tag) => {
                    const newVal = `${TagNo}`;
                    const isActive = FilterItems.filter(
                        (item: I_FilterItem) => item.value === newVal
                    );
                    const props = {
                        data: FilterItems,
                        nowType: filterTypesKey.CategoryList,
                        text: TagName,
                        value: newVal,
                        subValue: TripTypeCode,
                    };
                    // IT給的Tags
                    return (
                        <li
                            key={`${TagNo}${TagName}`}
                            className={styles.Tagwrap}
                            onClick={() => {
                                const newFilterItems = updateFilterItems(props);
                                dispatch(setFilterItems(newFilterItems));
                                dispatch(setChangeItem(true));
                            }}
                        >
                            <Tag.Selectable text={TagName} isActive={isActive.length !== 0} />
                        </li>
                    );
                });
            })}
        </>
    );
};

export default Type;
